/* Three-offer buy box.
 *
 * Owns three things: pushing the chosen offer's variant + quantity into the
 * product form, telling the sibling free-gifts panel how many gifts the
 * chosen offer unlocks, and (where Loop plans exist) resolving the subscribe
 * checkbox + frequency into a selling_plan id.
 *
 * The form is the theme's own product form, so we write into whatever inputs
 * it already has rather than adding our own duplicates -- a second element
 * named "quantity" would post twice and Shopify would take the last one.
 */
(function () {
  'use strict';

  function findForm(root) {
    var id = root.getAttribute('data-form-id');
    return (id && document.getElementById(id)) || root.closest('form');
  }

  /* Reuse an existing control if the theme rendered one, otherwise create a
   * hidden input. buy_buttons hides the quantity selector on the LPs, so on
   * those pages there is nothing to reuse. */
  function fieldFor(form, name, ownerRoot) {
    if (!form) return null;
    var existing = form.elements[name];
    if (existing) return existing.length && existing.tagName !== 'SELECT' ? existing[0] : existing;

    var made = ownerRoot.querySelector('input[data-made-for="' + name + '"]');
    if (!made) {
      made = document.createElement('input');
      made.type = 'hidden';
      made.name = name;
      made.setAttribute('data-made-for', name);
      ownerRoot.appendChild(made);
      if (form.id) made.setAttribute('form', form.id);
    }
    return made;
  }

  /* "30:10=123,30=456" -- frequency[:discount] = plan id. Discount is optional
   * so a flat-rate product can be mapped with just "30=456". */
  function parsePlanMap(raw) {
    var out = {};
    (raw || '').split(/[\n,]/).forEach(function (line) {
      var m = line.trim().match(/^(\d+)(?::([\d.]+))?\s*=\s*(\d+)$/);
      if (m) out[m[1] + (m[2] ? ':' + m[2] : '')] = m[3];
    });
    return out;
  }

  function init(root) {
    if (root.__offerInit) return;
    root.__offerInit = true;

    var form = findForm(root);
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    if (!offers.length) return;

    /* Own the add.
     *
     * Two separate submitters are bound to this product form on these pages --
     * the theme's own jQuery handler and an app's fetch-based one -- so a single
     * click posted /cart/add twice and the customer was charged for two of the
     * selected offer ($448 on a $224 tier). Both go through the form's submit
     * event, so one capture-phase intercept stops both, and we then perform
     * exactly one add ourselves from the fields this script already maintains.
     *
     * Reuses the shared cart helper. It is defined by offer-boxes.js, which
     * loads first; the lookup is deferred to click time regardless, so script
     * order can change without breaking this.
     */
    if (form && !form.__offerSelectorOwnsAdd) {
      form.__offerSelectorOwnsAdd = true;

      form.addEventListener('submit', function (e) {
        var core = window.NutsolaOfferBox;
        if (!core) return; // fall through to the theme rather than block the sale

        e.preventDefault();
        e.stopImmediatePropagation();

        function value(name) {
          var el = form.elements[name];
          if (!el) return '';
          if (el.length && el.tagName !== 'SELECT') {
            for (var i = 0; i < el.length; i++) if (el[i].checked || el[i].type === 'hidden') return el[i].value;
            return el[0].value;
          }
          return el.value;
        }

        var id = value('id');
        if (!id) return;

        var item = { id: id, quantity: parseInt(value('quantity'), 10) || 1 };
        var plan = value('selling_plan');
        if (plan) item.selling_plan = plan;

        var btn = form.querySelector('button[type="submit"], button[name="add"]');
        if (btn) btn.classList.add('is-loading');

        core.addToCart([item])
          .catch(function (err) {
            console.warn('[offer-selector] add to cart failed: ' + (err && err.message));
          })
          .then(function () {
            if (btn) btn.classList.remove('is-loading');
          });
      }, true);
    }

    var subWrap = root.querySelector('[data-offer-sub]');
    var subToggle = subWrap && subWrap.querySelector('[data-offer-sub-toggle]');
    var subFreq = subWrap && subWrap.querySelector('[data-offer-sub-freq]');
    var planInput = subWrap && subWrap.querySelector('[data-offer-plan]');
    var planMap = subWrap ? parsePlanMap(subWrap.getAttribute('data-plan-map')) : {};

    /* The gifts panel is a sibling block, so scope the lookup to the section
     * rather than the document -- two featured-product sections on one page
     * must not cross-wire. */
    var scope = root.closest('.shopify-section') || document;
    var gifts = scope.querySelector('.free-gifts');

    function applyPlan() {
      if (!planInput) return;
      if (!subToggle || !subToggle.checked) {
        planInput.value = '';
        return;
      }
      var freq = subFreq ? subFreq.value : '30';
      // Prefer an exact frequency:discount key, fall back to frequency alone.
      var hit = planMap[freq];
      if (!hit) {
        var pref = freq + ':';
        Object.keys(planMap).forEach(function (k) {
          if (!hit && k.indexOf(pref) === 0) hit = planMap[k];
        });
      }
      planInput.value = hit || '';
    }

    function select(offer) {
      offers.forEach(function (o) {
        o.classList.toggle('is-selected', o === offer);
      });

      var variantId = offer.getAttribute('data-variant-id');
      var qty = offer.getAttribute('data-quantity') || '1';

      var idField = fieldFor(form, 'id', root);
      if (idField && variantId) {
        idField.value = variantId;
        // The theme's price/availability JS listens on the original selector.
        idField.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var qtyField = fieldFor(form, 'quantity', root);
      if (qtyField) qtyField.value = qty;

      if (gifts) {
        var unlocked = parseInt(offer.getAttribute('data-gifts'), 10) || 0;
        gifts.setAttribute('data-unlocked', unlocked);
        gifts.querySelectorAll('[data-gift-index]').forEach(function (item) {
          var idx = parseInt(item.getAttribute('data-gift-index'), 10) || 0;
          item.classList.toggle('is-locked', idx > unlocked);
        });
      }

      applyPlan();
      showCover(offer);
    }

    /* Jump the product gallery to this offer's cover slide, if the block gave
       it one. The section renders those slides in front of the product media
       with data-media-id="offer-cover-N"; slick owns the gallery, so go
       through it (its afterChange hook keeps the thumbnails in sync). */
    function showCover(offer) {
      var cover = offer.getAttribute('data-cover');
      // The shared core filters the gallery down to this offer's cover
      // (offer-boxes.js loads first); the code below is only a fallback.
      if (window.NutsolaOfferBox && window.NutsolaOfferBox.showCover) {
        return window.NutsolaOfferBox.showCover(root, cover || '');
      }
      if (!window.jQuery) return;
      var $slideshow = window.jQuery(scope).find('.product-slideshow').first();
      if (!$slideshow.length || !$slideshow.hasClass('slick-initialized')) return;
      // No cover for this offer: fall back to the first real product photo so
      // the gallery never stays parked on another offer's cover.
      var $slide = cover
        ? $slideshow.find('.slide[data-media-id="' + cover + '"]').first()
        : $slideshow.find('.slide:not(.slide--offer-cover)').first();
      if (!$slide.length) return;
      var index = parseInt($slide.attr('data-slick-index'), 10);
      if (isNaN(index)) return;
      $slideshow.slick('slickGoTo', index);
    }

    offers.forEach(function (offer) {
      var radio = offer.querySelector('.offer-selector__radio');
      offer.addEventListener('change', function () {
        if (radio && radio.checked) select(offer);
      });
      // Clicking the row body should pick it even when the click misses the input.
      offer.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        if (radio && !radio.checked) {
          radio.checked = true;
          select(offer);
        }
      });
    });

    if (subToggle) subToggle.addEventListener('change', applyPlan);
    if (subFreq) subFreq.addEventListener('change', applyPlan);

    var initial = offers.filter(function (o) {
      var r = o.querySelector('.offer-selector__radio');
      return r && r.checked;
    })[0] || offers[0];
    var initialRadio = initial.querySelector('.offer-selector__radio');
    if (initialRadio) initialRadio.checked = true;
    select(initial);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-offer-selector]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var offer = e.target.closest && e.target.closest('[data-offer]');
    if (offer) {
      var r = offer.querySelector('.offer-selector__radio');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
})();
